import { Component, OnInit, OnDestroy } from '@angular/core';
import {LocalStorageService} from 'angular-2-local-storage';

declare global {
	interface Window {
		w1?: any;
	}
}

@Component({
	selector: 'app-chat-widget',
	template: ``,
	styles: []
})
export class ChatWidgetComponent implements OnInit, OnDestroy {
	private initTimer: any;
	private checkInterval: any;
	private initialized = false;

	constructor(private localStorageService: LocalStorageService) {}

	ngOnInit(): void {
		/*this.checkInterval = setInterval(() => {
			if (window.w1 && typeof window.w1 === 'function') {
				clearInterval(this.checkInterval);
				console.log('w1 function found, initializing widget');
				this.initChatWidget();
			}
		}, 500);

		this.initTimer = setTimeout(() => {
			if (!this.initialized) {
				clearInterval(this.checkInterval);
				console.error('Failed to initialize widget after 20 seconds');
			}
		}, 20000);*/
	}

	ngOnDestroy(): void {
		if (this.checkInterval) {
			clearInterval(this.checkInterval);
		}
		if (this.initTimer) {
			clearTimeout(this.initTimer);
		}
	}

	private initChatWidget(): void {
		try {
			if (!document.getElementById('chat-root')) {
				console.error('Target element #chat-root not found');
				return;
			}

			const chatToken = this.localStorageService.get('token') || '';

			console.log('seeing chat context', chatToken)

			window.w1('setchatcontext', { token: chatToken });

			this.initialized = true;
			console.log('Chat widget initialized successfully');
		} catch (error) {
			console.error('Error initializing chat widget:', error);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/chat-widget/chat-widget.component.ts